// Form Types:
import { formTypes } from 'utils/constants/formTypes'

// Form Configs:
import { CtFormConfig } from 'containers/common/formByState/forms/CTForm'
import { NjFormConfig } from 'containers/common/formByState/forms/NJForm'
import { OrFormConfig } from 'containers/common/formByState/forms/OR/ORForm'
import { CaFormConfig } from 'containers/common/formByState/forms/CA/CAForm'
import { PaFormConfig } from 'containers/common/formByState/forms/PAForm'
import { UtFormConfig } from 'containers/common/formByState/forms/UTForm'
import { DcFormConfig } from 'containers/common/formByState/forms/DCForm'
import { AZFormConfig } from 'containers/common/formByState/forms/AZForm'
import { NmFormConfig } from 'containers/common/formByState/forms/NMForm'
import { MiFormConfig } from 'containers/common/formByState/forms/MIForm'

export const getFormConfigByType = ({ form }) => {
  const { type } = form

  switch (type) {
    case formTypes.CT_EMPLOYMENT_REFERENCE:
      return CtFormConfig
    case formTypes.NJ_EMPLOYMENT_REFERENCE:
      return NjFormConfig
    case formTypes.MI_EMPLOYMENT_REFERENCE:
      return MiFormConfig
    case formTypes.OR_EMPLOYMENT_REFERENCE:
      return OrFormConfig
    case formTypes.CA_EMPLOYMENT_REFERENCE:
      return CaFormConfig
    case formTypes.PA_EMPLOYMENT_REFERENCE:
      return PaFormConfig
    case formTypes.UT_EMPLOYMENT_REFERENCE:
      return UtFormConfig

    case formTypes.AZ_EMPLOYMENT_REFERENCE:
      return AZFormConfig
    case formTypes.DC_EMPLOYMENT_REFERENCE:
      return DcFormConfig
    case formTypes.NM_EMPLOYMENT_REFERENCE:
      return NmFormConfig

    default:
      return {}
  }
}

export const getInitialValuesByType = ({ form }) => {
  const { type } = form

  // Update NJ form checkbox attributes to false, as we need to send them as false to BE if user doesn't touch them
  if (type === formTypes.MI_EMPLOYMENT_REFERENCE) {
    return {
      ...form?.attributes,
      noUnprofessionalConduct: false,
      commentedOnUnprofessionalConduct: false,
    }
  }

  // Just return attributes for other forms
  return form.attributes
}
